import React from "react";
import "./HomeDashboard.css";
import WildlifeThreatsPanel from "./WildlifeThreatsPanel";
import DroneMapping from "./DroneMapping";
import InsightsOverview from "./InsightsOverview";
import DroneStreaming from "./DroneStreaming";
import IoTSensing from "./IoTSensing";

const HomeDashboard = () => {
  return (
    <div className="home-dashboard">
      
      <div className="dashboard-row top-row top-row-panels">
        <WildlifeThreatsPanel />
        <DroneMapping />
        <IoTSensing />
      </div>

      
      <div className="dashboard-row bottom-row">
        <DroneStreaming />
        <InsightsOverview />
        
      </div>
    </div>
  );
};

export default HomeDashboard;
